import { apiFetch } from '~/shared/api/api-fetch';

/**
 * Авторизация юзера по коду. Тела в ответе нет — бэкенд ставит куку сессии.
 * @param authorizationCode - код, передаваемый lims в redirect url
 */
export function confirmLimsAuth(authorizationCode: string) {
  return apiFetch('/ui/v1/auth-by-lims/confirm', {
    method: 'POST',
    body: { token: authorizationCode },
  });
}

/** Гасит куку сессии — из JS она недоступна */
export function logout() {
  return apiFetch('/ui/v1/auth/logout', { method: 'POST' });
}
